/** @format */

import { useEffect, useState } from "react";

function useStickyState(defaultValue, key) {
  const [value, setValue] = useState(() => {
    const stickyValue = window.localStorage.getItem(key);
    return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
  });
  useEffect(() => {
    window.localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
  return [value, setValue];
}

function useStickyDate(defaultValue, key) {
  const [value, setValue] = useState(() => {
    const stickyValue = window.localStorage.getItem(key);
    return stickyValue !== null ? new Date(stickyValue) : defaultValue;
  });
  useEffect(() => {
    window.localStorage.setItem(key, value.toString());
  }, [key, value]);
  return [value, setValue];
}

export { useStickyState, useStickyDate };
